"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_struct_1 = require("./action-struct");
function nextMonth() {
    return {
        type: action_struct_1.ActionType.NextMonth
    };
}
exports.nextMonth = nextMonth;
function previousMonth() {
    return {
        type: action_struct_1.ActionType.PreviousMonth
    };
}
exports.previousMonth = previousMonth;
function addDays(numberOfDays, extendDays) {
    if (extendDays === void 0) { extendDays = false; }
    return {
        type: action_struct_1.ActionType.AddDays,
        value: { numberOfDays: numberOfDays, extendDays: extendDays }
    };
}
exports.addDays = addDays;
function setMonth(month) {
    return {
        type: action_struct_1.ActionType.SetMonth,
        value: month
    };
}
exports.setMonth = setMonth;
function goToMonth(month) {
    return {
        type: action_struct_1.ActionType.GoToMonth,
        value: month
    };
}
exports.goToMonth = goToMonth;
function setDates(startDate, endDate) {
    return {
        type: action_struct_1.ActionType.SetDates,
        value: { startDate: startDate, endDate: endDate }
    };
}
exports.setDates = setDates;
function updateEventFilter(filterFunction) {
    return {
        type: action_struct_1.ActionType.UpdateEventFilter,
        value: filterFunction
    };
}
exports.updateEventFilter = updateEventFilter;
function changeProductionSeasonFilter(filter) {
    return {
        type: action_struct_1.ActionType.ChangeProductionSeasonFilter,
        value: filter
    };
}
exports.changeProductionSeasonFilter = changeProductionSeasonFilter;
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adage/ace-calendar/app/actions/actions.js
// module id = 139
// module chunks = 0